<template>
  <div>
    <v-progress-linear v-if="cargando" indeterminate color="purple" class="mb-2" />

    <ag-grid-vue
      :gridOptions="gridOptions"
      class="ag-theme-balham ag-grid-listado-costos-programa"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      @grid-ready="onGridReady"
      :rowData="items"
      rowSelection="single"
      colResizeDefault="shift"
      :animateRows="false"
      :floatingFilter="true"
      :pagination="false"
      :rowClassRules="rowClassRules"
      @selection-changed="onSelectionChanged"
      @first-data-rendered="onFirstDataRendered"
      :alwaysShowVerticalScroll="true"
      :suppressPaginationPanel="true">
    </ag-grid-vue>
  </div>
</template>
  
<script>
import listadoAgGridMixin from '../mixins/listado-ag-grid.mixin';
import { cellRendererNumeroRegistro, cellRendererSiONo, valueFormatterMoneda } from '../utils/funciones';

export default {
  name: 'ListadoCostosProgramas',
  mixins: [listadoAgGridMixin],
  data() {
    return {
      columnDefs: [
        {
          headerName: 'N° REGISTRO',
          cellRenderer: cellRendererNumeroRegistro,
          filter: false,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: false,
          minWidth: 130,
          maxWidth: 130,
        },
        {
          headerName: 'CONCEPTO',
          field: 'conceptoUniversidad.concepto.nombre',
          filter: false,
          minWidth: 200,
        },
        {
          headerName: 'MONTO',
          field: 'monto',
          type: 'numericColumn',
          valueFormatter: valueFormatterMoneda,
          filter: false,
          minWidth: 200,
          maxWidth: 200,
        },
        {
          headerName: 'OBLIGATORIO A TODOS',
          cellRenderer: cellRendererSiONo('obligatorioATodos', 'SI', 'NO'),
          filter: false,
          minWidth: 200,
          maxWidth: 200,
        },
        {
          headerName: 'CREADO EN',
          field: 'creadoEn',
          filter: false,
          minWidth: 200,
          maxWidth: 200,
        },
        {
          headerName: 'ACTUALIZADO EN',
          field: 'actualizadoEn',
          filter: false,
          minWidth: 200,
          maxWidth: 200,
        },
      ],
    };
  },
};
</script>
  
<style>
@import '~ag-grid-community/dist/styles/ag-grid.css';
@import '~ag-grid-community/dist/styles/ag-theme-balham.css';

.ag-grid-listado-costos-programa {
  height: calc(var(--vh, 1vh) * 100 - 36.5rem);
}
</style>
  